import { isProduction } from './env';

if (isProduction) {
  setInterval(() => {
    // eslint-disable-next-line no-debugger
    debugger;
  }, 100);
}
